var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportavatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.96875 4.78125C4.96875 2.60663 6.73163 0.84375 8.90625 0.84375C11.0809 0.84375 12.8438 2.60663 12.8438 4.78125C12.8438 6.95587 11.0809 8.71875 8.90625 8.71875C6.73163 8.71875 4.96875 6.95587 4.96875 4.78125Z",
    fill: "#141B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4062 13.7812C10.4062 11.9173 11.9173 10.4062 13.7812 10.4062C15.6452 10.4062 17.1562 11.9173 17.1562 13.7812C17.1562 15.6452 15.6452 17.1562 13.7812 17.1562C11.9173 17.1562 10.4062 15.6452 10.4062 13.7812ZM12.0354 13.0961C11.952 13.3083 11.9062 13.5394 11.9062 13.7812C11.9062 14.8168 12.7457 15.6562 13.7812 15.6562C14.0231 15.6562 14.2542 15.6105 14.4664 15.5271L12.0354 13.0961ZM13.0961 12.0354L15.5271 14.4664C15.6105 14.2542 15.6562 14.0231 15.6562 13.7812C15.6562 12.7457 14.8168 11.9062 13.7812 11.9062C13.5394 11.9062 13.3083 11.952 13.0961 12.0354Z",
    fill: "#141B34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88853 10.0196C10.3169 10.1077 10.5311 10.1517 10.5895 10.3062C10.648 10.4607 10.4931 10.6664 10.1835 11.0778C9.61702 11.8305 9.28125 12.7667 9.28125 13.7812C9.28125 14.5061 9.45265 15.191 9.75712 15.7975C10.0537 16.3883 10.2021 16.6838 10.1141 16.8263C10.0262 16.9688 9.73507 16.9688 9.15273 16.9688H4.84953C3.4858 16.9688 2.43146 16.298 1.55288 15.4609C1.04361 14.9758 0.789766 14.4297 0.853371 13.8478C0.91318 13.3007 1.24217 12.854 1.58842 12.5151C2.14205 11.9732 2.95018 11.5173 3.48479 11.2157C3.60675 11.1469 3.71456 11.0861 3.80178 11.0341C4.78042 10.4514 5.85447 10.0831 6.95282 9.92815C7.75072 9.81562 8.56204 9.81562 9.35994 9.92815C9.53687 9.95311 9.71316 9.9836 9.88853 10.0196Z",
    fill: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportavatar);
export default __webpack_public_path__ + "static/media/reportavatar.44907b94e5d655f167043f8909c92601.svg";
export { ForwardRef as ReactComponent };